import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { Listing, BiometricsaddEdit,CustomerCardAddEdit } from './Pages';

export const CustomerRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={Listing} />
        <Route exact path = {`${match.path}/customerBiometricsAddEdit/:id?`} component={BiometricsaddEdit} />
        <Route exact path = {`${match.path}/CustomerCardAddEdit`} component={CustomerCardAddEdit} />
    </Fragment>
)